import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const SEND_PLATFORM_MAIL = gql(`
  mutation sendPlatformMail($sendGridTemplateID: String!, $emailCategory: EmailNotificationCategory!, $userType: Role!, $testMail: Boolean!) {
    sendPlatformMail(input:  {
      sendGridTemplateID: $sendGridTemplateID,
      emailCategory: $emailCategory,
      userType: $userType,
      testMail: $testMail
    }) {
      __typename
      testMail
      to
    }
  }
`);

export function useSendPlatformMail() {
  return useMutation(SEND_PLATFORM_MAIL);
}
